var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("base-tutorial", { attrs: { steps: _vm.steps } }, [
    _c("div", [
      _c("h2", [
        _vm._v(
          " Olá! Nesta etapa vamos consolidar as responsabilidades, bem como os níveis de impacto, dificuldade e as competências técnicas validadas. "
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [
        _vm._v(
          " Na aba “Competências”, você encontra os filtros: “Unidade(s)”: selecione a(s) unidade(s) com a(s) qual(is) você trabalhará nesta aba. Após selecionada(s), é possível visualizar todas as competências associadas as responsabilidades cadastradas na unidade. “Situação”: neste filtro você pode visualizar “todas”; “competências gerais” e “competências inseridas”. “Pesquisar”: possibilita a busca por qualquer termo cadastrado. "
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [
        _vm._v(
          " No filtro “Unidades”, sugere-se selecionar “todas” e no filtro “Situação”, indica-se selecionar “todas”. O sistema, então, apresentará a tabela com as “Competências técnicas”. Inicialmente, sugere-se observar se há alguma competência que não está associada a nenhuma responsabilidade, ou seja, apresenta o ícone “engrenagem” zerado. Neste caso, realiza-se a exclusão da competência clicando no ícone “lixeira”. Na coluna “Competências”, deve-se observar se foram inseridos termos idênticos ou semelhantes e selecioná-los para agrupamento em uma única competência técnica, visando padronizar o texto, sintetizar e evitar redundâncias. Na coluna “Responsabilidades”, ao clicar no ícone “engrenagem”, pode-se observar as unidades e suas responsabilidades relacionadas a cada competência. Na última coluna, é possível visualizar o ícone “lápis”, que permite realizar a edição no texto da competência. No ícone “lixeira”, você pode excluir a Competência. "
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [
        _vm._v(
          " Na aba “Responsabilidades”, você encontra os filtros: “Unidade(s)”: selecione a(s) unidade(s) com a(s) qual(is) você trabalhará nesta aba. Após selecionada(s), é possível visualizar todas as responsabilidades cadastradas pelo(s) gestor(es) responsável(is). “Situação”: neste filtro você pode visualizar “todas”; “arquivadas”; “consolidadas”; “não consolidadas”; “validadas” e “não validadas”. “Pesquisar”: possibilita a busca por qualquer termo cadastrado. “Ordenar por”: organiza as responsabilidades de acordo com o grau de dificuldade; o grau de impacto; a responsabilidade; o número de competências e a unidade. Ainda é possível organizar em ordem alfabética ou crescente e decrescente, utilizando a seta. "
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [
        _vm._v(
          " No filtro “Unidade”, selecione uma unidade por vez para visualizar as responsabilidades. No filtro “Situação”, selecione a opção “Validadas”. Realize a revisão do texto das responsabilidades, das competências associadas, grau de impacto e dificuldade, verificando se há alguma inconsistência e, se necessário, faça a edição. Selecione uma responsabilidade ou todas, clique no botão “Consolidar”. Após todas as responsabilidades estarem consolidadas, clique no botão “Finalizar”. Se necessário, é possível obter a lista das responsabilidades consolidadas e arquivadas na unidade selecionada, clicando no botão “Baixar XLS”. "
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Importante!")]),
      _c("h2", [
        _vm._v(
          " É possível, dentro do prazo estabelecido para a consolidação, reverter esta ação, caso necessário editar uma responsabilidade. Lembre-se de consolidá-la novamente e finalizar a ação. Caso as responsabilidades de uma unidade não tenham sido validadas, no filtro “Situação”, selecione a opção “Não validadas” e realize a consolidação normalmente. "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }